import { Extension } from '@tiptap/core'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    indent: {
      indent: () => ReturnType,
      outdent: () => ReturnType,
    }
  }
}

const IndentExtension = Extension.create({
  name: 'indent',
  
  addGlobalAttributes() {
    return [{
      types: ['paragraph'], // or other block types you want to indent
      attributes: {
        indent: {
          default: 0,
          renderHTML: attrs => {
            if (!attrs.indent) return {};
            return {
              style: `margin-left: ${attrs.indent * 30}px`,
            }
          },
          parseHTML: element => {
            const margin = element.style.marginLeft || '0';
            return parseInt(margin, 10) / 30 || 0;
          }
        }
      }
    }]
  },

  addCommands() {
    return {
      indent: () => ({ tr, state, dispatch }) => {
        const { selection } = state;
        const { from, to } = selection;
        let updated = false;

        state.doc.nodesBetween(from, to, (node, pos) => {
          if (node.type.name === 'paragraph') {
            const currentIndent = node.attrs.indent || 0;
            const newIndent = currentIndent + 1;
            tr.setNodeMarkup(pos, undefined, {
              ...node.attrs,
              indent: newIndent,
            });
            updated = true;
          }
        });

        if (updated && dispatch) {
          dispatch(tr);
          return true;
        }
        return false;
      },

      outdent: () => ({ tr, state, dispatch }) => {
        const { selection } = state;
        const { from, to } = selection;
        let updated = false;

        state.doc.nodesBetween(from, to, (node, pos) => {
          if (node.type.name === 'paragraph') {
            const currentIndent = node.attrs.indent || 0;
            const newIndent = Math.max(currentIndent - 1, 0);
            tr.setNodeMarkup(pos, undefined, {
              ...node.attrs,
              indent: newIndent,
            });
            updated = true;
          }
        });

        if (updated && dispatch) {
          dispatch(tr);
          return true;
        }
        return false;
      }
    }
  }
})

export default IndentExtension;
